// A next page exists only when the last page came back full; skip is the
// number of rows loaded so far.
export const getNextPageSkip =
  (limit: number) =>
  <T>(lastPage: { data: T[] }, allPages: { data: T[] }[]) =>
    lastPage.data.length < limit
      ? undefined
      : allPages.reduce((acc, page) => acc + page.data.length, 0)
